export default __webpack_public_path__ + "static/media/004-romantic novel.ecdb6748.svg";